import React, { useState } from 'react';
  const API_URL = process.env.REACT_APP_API_URL;

const BotModeToggle = ({ conversationId, initialMode = 'bot', onModeChange = null }) => {
  const [mode, setMode] = useState(initialMode);
  const [isLoading, setIsLoading] = useState(false);


  const handleToggle = async () => {
    if (!conversationId) {
      console.error("Se requiere el conversationId para cambiar el modo");
      return;
    }

    setIsLoading(true);

    try {
      // Llamada al endpoint que proporcionaste
      const response = await fetch(`${API_URL}conversations/toggle-mode`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ conversationId }),
      });

      const data = await response.json();

      if (data.success) {
        // Actualizamos el estado local con el nuevo modo que devuelve el backend
        setMode(data.newMode);
        
        // Si el componente padre (ChatWindow) necesita saber del cambio, ejecutamos el callback
        if (onModeChange) {
          onModeChange(data.newMode);
        }
      } else {
        console.error("Error desde el servidor:", data.error);
        alert("No se pudo cambiar el modo de la conversación.");
      }
    } catch (error) {
      console.error("Error en la petición de red:", error);
      alert("Error de conexión al cambiar el modo.");
    } finally {
      setIsLoading(false);
    }
  };

  const isBot = mode === 'bot';

  return (
    <div style={{display:'inline-block', marginLeft: '20px'}}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontFamily: 'sans-serif' }}>
      {/* Etiqueta Humano */}
      <span 
        style={{ 
          fontSize: '14px', 
          color: isBot ? '#888' : '#075E54', // Color más oscuro si está activo
          fontWeight: !isBot ? '600' : 'normal',
          transition: 'color 0.3s'
        }}
      >
        Humano
      </span>
      
      {/* Botón Switch */}
      <button 
        onClick={handleToggle}
        disabled={isLoading}
        style={{
          position: 'relative',
          width: '44px',
          height: '24px',
          backgroundColor: isBot ? '#25D366' : '#CBD5E1', // Verde estilo WA para bot, gris para humano
          borderRadius: '12px',
          border: 'none',
          cursor: isLoading ? 'wait' : 'pointer',
          transition: 'background-color 0.3s ease',
          padding: '2px',
          display: 'flex',
          alignItems: 'center',
          opacity: isLoading ? 0.7 : 1
        }}
        aria-label="Alternar modo de conversación"
        title={`Cambiar a modo ${isBot ? 'Humano' : 'Bot'}`}
      >
        {/* Círculo deslizable del switch */}
        <div 
          style={{
            width: '20px',
            height: '20px',
            backgroundColor: 'white',
            borderRadius: '50%',
            boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
            transition: 'transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
            transform: isBot ? 'translateX(20px)' : 'translateX(0)'
          }}
        />
      </button>

      {/* Etiqueta Bot */}
      <span 
        style={{ 
          fontSize: '14px', 
          color: isBot ? '#25D366' : '#888', 
          fontWeight: isBot ? '600' : 'normal',
          transition: 'color 0.3s'
        }}
      >
        IA
      </span>
    </div>
    </div>
  );
};

export default BotModeToggle;